<template>
  <div class="app-page__container">
    <div v-if="!isLoading">
      <div class="app-page__header">
        <h5 class="title is-5">{{ activeTeam.teamName }}</h5>
        <p class="subtitle is-size-6">
          {{ `${numberOfTeamMembers} Member${numberOfTeamMembers === 1 ? '' : 's'}` }}
        </p>
        <DatePicker
          :active-team-ids="[activeTeamId]"
          @activeDateChanged="handleActiveDateChange"
        />
      </div>
      <section v-if="!areTeammatesLoading" class="app-page__section u-p-t-small">
        <TeamGoals
          :activeDate="activeDate"
          :activeTeamIds="[activeTeamId]"
          :isHitRateVisibleOnAvatars="true"
        />
      </section>
    </div>
    <div v-else style="position: relative; min-height: 150px;">
      <BLoading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></BLoading>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import * as UserActions from '@/store/actions/User.actions';
import * as TeamActions from '@/store/actions/Team.actions';
import TeamGoals from '@/components/TeamGoals.vue';
import DatePicker from '@/components/DatePicker.vue';
import { isObjectEmpty } from '@/helpers/dataHelpers';

export default {
  name: 'TeamGoalsView',

  components: {
    TeamGoals,
    DatePicker,
  },

  data() {
    return {
      activeTeamId: null,
      areTeammatesLoading: true,
      isActiveTeamLoading: true,
      activeDate: new Date(),
    };
  },

  computed: {
    ...mapState({
      teams: state => state.team.teams,
    }),
    ...mapGetters([
      'activeWorkspace',
    ]),
    activeTeam() {
      return this.teams[this.activeTeamId] || {};
    },
    numberOfTeamMembers() {
      if (isObjectEmpty(this.activeTeam)) return 0;

      return this.activeTeam.userIds.length || 0;
    },
    isLoading() {
      return this.isActiveTeamLoading || this.areTeammatesLoading;
    },
  },

  created() {
    this.fetchTeamDataOnLoad();
  },

  watch: {
    '$route'() { // eslint-disable-line object-shorthand
      this.fetchTeamDataOnLoad();
    },
  },

  methods: {
    ...mapActions({
      fetchWorkspaceUsersByIds: UserActions.FETCH_WORKSPACE_USERS_BY_IDS,
      fetchTeams: TeamActions.FETCH_TEAMS_BY_IDS,
    }),
    async fetchTeamDataOnLoad() {
      this.isActiveTeamLoading = true;
      this.areTeammatesLoading = true;
      this.activeTeamId = this.$route.params.id;

      await this.fetchTeams({ teamIds: [this.activeTeamId] });
      this.isActiveTeamLoading = false;
      await this.fetchWorkspaceUsersByIds({ userIds: this.activeTeam.userIds, workspaceId: this.activeWorkspace.id });
      this.areTeammatesLoading = false;
    },
    handleActiveDateChange(newDate) {
      this.activeDate = newDate;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
